export default __webpack_public_path__ + "static/media/AboutLight.7afc9e3e.svg";